import React from 'react';
import { Row, Col, Container, Image } from 'react-bootstrap';

function Certificates() {

    return(
        <React.Fragment>
        <Container fluid className="dark container" id="certificates">
            <br></br>
            <h1 className="text-center">Certifications</h1>
            <hr/>
            <Row>
                <Col className="headline">
                    <p>Although, i believe to show my knowledge in my work rather then showing it through certificates,
                        still having some genuine certificates don't harm.
                        So these are few certification courses i have done in the holidays during pandemic of COVID-19. </p>
                </Col>       
            </Row>
            <Row>
                <Col xs={12} md={6} className="justify-content-center certificates">
                    <Image src="./images/HTML.png" thumbnail  />
                </Col>
                <Col xs={12} md={6} className="justify-content-center certificates">
                    <Image src="./images/CSS.png" thumbnail  />
                </Col>           
            </Row>
            <Row >
                <Col xs={12} md={6} className="justify-content-center certificates">
                    <Image src="./images/BOOTSTRAP.png" thumbnail  />
                </Col>
                <Col xs={12} md={6} className="justify-content-center certificates">
                    <Image src="./images/REACT.png" thumbnail  />
                </Col>           
            </Row>
            
        </Container> 
        </React.Fragment>
    )
}

export default Certificates;